import { takeLatest, all } from "redux-saga/effects";

export function* updateProfile() {
}

export default all([takeLatest("@user/UPDATE_PROFILE_REQUEST", updateProfile)]);
